import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

interface StepperProps {
  activeIndex?: number;
  steps?: string[];
}

interface StepProps {
  active: boolean;
  number: number;
  label: string;
}

const Step: FunctionComponent<StepProps> = ({ active, number, label }) => (
  <Box sx={{ position: 'relative' }}>
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '38px',
        height: '38px',
        border: '2px solid #D41C62',
        borderRadius: '50%',
        boxSizing: 'border-box',
        color: active ? '#FFFFFF' : '#D41C62',
        background: active ? '#D41C62' : '#FFFFFF',
        fontWeight: 500,
        fontSize: '20px',
      }}
    >
      {number}
    </Flex>
    <Box
      sx={{
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: '50%',
        color: 't.grey500',
        fontWeight: active ? 700 : 400,
        whiteSpace: 'nowrap',
        transform: 'translateX(-50%)',
      }}
    >
      {label}
    </Box>
  </Box>
);

const Stepper: FunctionComponent<StepperProps> = ({
  activeIndex = 0,
  steps = [],
}) => {
  return (
    <Flex
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 's',
        width: '100%',
        paddingBottom: '24px',
        marginBottom: '44px',
      }}
    >
      {steps.map((step, index) => (
        <>
          {index > 0 && (
            <Box
              sx={{ width: '100px', height: '1px', background: 't.black60' }}
            />
          )}
          <Step
            key={step}
            active={index === activeIndex}
            number={index + 1}
            label={step}
          />
        </>
      ))}
    </Flex>
  );
};

export default Stepper;
